import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '../typography';
export function CardLabel({ children }) {
    return (_jsx(Text, { className: "text-gray-800 font-medium text-sm mb-1.5", children: children }));
}
